<template>
  <div
    class="
      tw-flex
      tw-flex-col
      tw-gap-2
      tw-px-6
      tw-py-4
      tw-border-solid
      tw-border-x-0
      tw-bg-sf-snow-lighter
      tw-border-sf-neutral-lighter-2
      tw-border-b
      tw-border-t-0
    "
  >
    <SfSkeletonLoader width="25%" />
    <SfSkeletonLoader />
  </div>
</template>

<script setup lang="ts">
import SfSkeletonLoader from '@app/shared/vue/components/sf-skeleton-loader.vue'
</script>
